import React, { Component, useState } from 'react';
import { SelectorViewer, ProductsList, ComplexSelector } from '.';
import { PropTypes } from 'prop-types';
import { Badge, Box, Button, Drawer, Icon, IconButton } from '@mui/material';
import { translate } from '../../../../services';
import { FilterIconNew, filterIcon } from '../../../../../style/images';


const SelectorViewComponentMemo = React.memo(({currentSelector, onSelectorChanged, parentSelector, onClose, resetHeader, showResetHeader, setShowResetHeader})=>{

  const [filterCount, setFilterCount] = useState(0)
  const [totalFilterCount, setTotalFilterCount] = useState(0)

  const updateFilterCount = (count) =>{
    setFilterCount(count);
  }

  const updateTotalFilterCount = (count) => {
    setTotalFilterCount(count);
  }

  if ( parentSelector && parentSelector.isComplexSelector ) {
    if( !currentSelector.modelToLoad ) {
      currentSelector.modelToLoad = parentSelector.complexSelector.configurations.firstOrDefault( conf => conf.name === parentSelector.name ).targetSelector;
    }

    return <ComplexSelector 
      selector={ parentSelector } 
      Component={SelectorViewer} 
      onSelectorChanged={ onSelectorChanged } 
      currentSelector={ currentSelector.selector } onClose={onClose} resetHeader={resetHeader} showResetHeader={showResetHeader} setShowResetHeader={setShowResetHeader}
    />;
  }

  const SelectorViewerComponent = SelectorViewer( currentSelector.selector.name );
  return <SelectorViewerComponent currentSelector={ currentSelector.selector } onClose={onClose} resetHeader={resetHeader} showResetHeader={showResetHeader} setShowResetHeader={setShowResetHeader}/>;
})

export class ProductView extends Component {

  constructor(props){
    super(props);
    this.state={
      products:[],
      toggle:false
    }
  }

  // updateFilterCount=(count)=>{
  //   this.setState({filterCount:count})
  // }

  // getSelectorComponent() {
  //   const { currentSelector, onSelectorChanged, parentSelector } = this.props;

  //   if ( parentSelector && parentSelector.isComplexSelector ) {
  //     if( !currentSelector.modelToLoad ) {
  //       currentSelector.modelToLoad = parentSelector.complexSelector.configurations.firstOrDefault( conf => conf.name === parentSelector.name ).targetSelector;
  //     }

  //     return <ComplexSelector 
  //       selector={ parentSelector } 
  //       Component={SelectorViewer} 
  //       onSelectorChanged={ onSelectorChanged } 
  //       currentSelector={ currentSelector.selector }  updateTotalFilterCount={this.updateTotalFilterCount} updateFilterCount={this.updateFilterCount} totalFilterCount={this.state.totalFilterCount} filterCount={this.state.filterCount} onClose={this.onToggle} resetHeader={this.props.resetHeader} showResetHeader={this.props.showResetHeader} setShowResetHeader={this.props.setShowResetHeader}
  //     />;
  //   }

  //   const SelectorViewerComponent = SelectorViewer( currentSelector.selector.name );
  //   return <SelectorViewerComponent currentSelector={ currentSelector.selector }  updateTotalFilterCount={this.updateTotalFilterCount} updateFilterCount={this.updateFilterCount} totalFilterCount={this.state.totalFilterCount} filterCount={this.state.filterCount} onClose={this.onToggle} resetHeader={this.props.resetHeader} showResetHeader={this.props.showResetHeader} setShowResetHeader={this.props.setShowResetHeader}/>;
  // }

  onToggle = ()=>{
    this.setState({toggle:!this.state.toggle})
  }
  render() {
    const { currentSelector, onConfigureRequest } = this.props;

    if ( !currentSelector ) {
      return null;
    }
    
    const ProductsListComponent = ProductsList( currentSelector.selector.name );

    return <div className="product-view">
    <Box className="product-view-container">
      <Box className="Selector-Component">
        <SelectorViewComponentMemo currentSelector={this.props.currentSelector}
          onSelectorChanged={this.props.onSelectorChanged}
          parentSelector={this.props.parentSelector}
          onClose={this.onToggle} 
          resetHeader={this.props.resetHeader} 
          showResetHeader={this.props.showResetHeader} 
          setShowResetHeader={this.props.setShowResetHeader}
        ></SelectorViewComponentMemo>
        {/* { this.getSelectorComponent() } */}
      </Box>
      <Box className='product'>
        <ProductsListComponent currentSelector={ currentSelector } onConfigureRequest={ onConfigureRequest } />
      </Box>
    </Box>
    </div>
  }
}

ProductView.propTypes = {
  onConfigureRequest: PropTypes.func,
  currentSelector: PropTypes.shape( {
    modelToLoad: PropTypes.string,
    selector: PropTypes.object
  } ), 
  onSelectorChanged: PropTypes.func, 
  parentSelector: PropTypes.shape( {
    complexSelector: PropTypes.object,
    isComplexSelector: PropTypes.bool
  } )
};